import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-350e143b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "snsUnlinkConfirmDialog",
  tabindex: "-1",
  "aria-labelledby": "updateUserComplete",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "text-center my-4 px-4"
}
const _hoisted_8 = { class: "modal-confirm-footer modal-footer d-flex justify-content-center" }
const _hoisted_9 = { class: "d-flex justify-content-lg-end justify-content-center" }
const _hoisted_10 = { class: "d-flex justify-content-lg-start justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { onMounted, ref } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  onUnlinkConfirm: {
    type: Function,
    default: (sns: string) => null,
  },
},
  setup(__props, { expose }) {



const modalConfirm = ref()
const platformName = ref<string>()
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('snsUnlinkConfirmDialog'))
})

expose({
  showConfirmModal: (platform): void => {
    platformName.value = platform
    modalConfirm.value.show()
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SD40UnlinkConfirm')), 1),
          _hoisted_6
        ]),
        (platformName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(translate)('SD40UnlinkMessage').replaceAll('%s', _unref(translate)(`SD40${platformName.value}DisplayName`))), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: _unref(translate)('SE40back'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Button, {
              class: "button-submit",
              "data-bs-dismiss": "modal",
              title: _unref(translate)('SD40RemoveLink'),
              type: 'secondary',
              onClick: __props.onUnlinkConfirm(platformName.value)
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ])
    ])
  ]))
}
}

})